var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-scatter-chart',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"plugins":_vm.plugins}})
}
var staticRenderFns = []

export { render, staticRenderFns }